// Toasts (sonner). Use `toast.success(...)` / `toast.error(...)` from 'sonner' anywhere in the app.
import { Toaster as Sonner } from 'sonner'

export { toast } from 'sonner'

export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      richColors
      toastOptions={{ classNames: { toast: 'font-sans text-sm', description: 'text-ink-muted' } }}
    />
  )
}
